export const routes = {
	onboarding: "/setup/onboarding",
	login: "/setup/login",
	signup: "/setup/signup",
	explore: "/",
	// TODO: add remaining routes
};
